module.exports = __webpack_public_path__ + "img/poster_bg_1.3dbbce33.png";